import { Box, IconButton, Stack, TableCell, TableRow } from '@mui/material'
import React from 'react'
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import SaveIcon from '@mui/icons-material/Save';


const ReadOnlyRowMoverAdd = ({ row, setDisponibilidadProducto, setEditRowId, handleSave }) => {

    const handleSaveClick = (event, row) => {
        event.preventDefault();
        handleSave(row);
    }
    
    const handleEditClick = (event, row) => {
        event.preventDefault();
        setEditRowId(row.lot);
    }

    return (
        <TableRow key={row.lot}>
            <TableCell key={row.lot + '_lot'} align='left'>{row.lot}</TableCell>
            <TableCell key={row.lot + '_cost'} align='left'>{row.cost}</TableCell>    
            <TableCell key={row.lot + '_price'} align='left'>
                <Box sx={{width: '100px'}}>
                    {row.currentPrice}
                </Box>    
            </TableCell>
            <TableCell key={row.lot + '_exp'} align='left'>{row.expD}</TableCell>
            <TableCell key={row.lot + '_tot'} align='left'>{row.totalFinal}</TableCell>
            <TableCell key={row.lot + '_mov'} align='left'>
                <Box sx={{width: '100px'}}>
                    {row.mover}
                </Box>
            </TableCell>

            <TableCell key={'controles_' + row.id} align='left'>
                <Stack direction='row' spacing={0}>
                    <IconButton aria-label="edit" onClick={(event) => handleEditClick(event, row)}>
                        <EditIcon fontSize="small" />
                    </IconButton>
                    <IconButton disabled={!row.mover} color="primary" aria-label="edit" onClick={(event) => handleSaveClick(event, row)}>
                        <SaveIcon fontSize="small" />
                    </IconButton>
                </Stack>
            </TableCell>
        </TableRow>
    )
}

export default ReadOnlyRowMoverAdd